import { render } from "./StepSettings.vue?vue&type=template&id=459e2670&scoped=true"
import script from "./StepSettings.vue?vue&type=script&lang=js"
export * from "./StepSettings.vue?vue&type=script&lang=js"

import "./StepSettings.vue?vue&type=style&index=0&id=459e2670&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459e2670"]])

export default __exports__